import { lazy } from 'react';

export const BenchmarkPageLazy = lazy(() => import('./BenchmarkPage'));
